export default __webpack_public_path__ + "static/media/x.6fa3f6cf.svg";